module.exports = __webpack_public_path__ + "static/media/balkerne-logo.f88c4ea8.png";